export default __webpack_public_path__ + "static/mpos-solution-b84a11d210c91e62d72774a5f2a99fc2.png";